import { render, staticRenderFns } from "./add-group-mutrules.vue?vue&type=template&id=4f441041&scoped=true&"
import script from "./add-group-mutrules.vue?vue&type=script&lang=js&"
export * from "./add-group-mutrules.vue?vue&type=script&lang=js&"
import style0 from "./add-group-mutrules.vue?vue&type=style&index=0&id=4f441041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f441041",
  null
  
)

export default component.exports